import { buildPxCheck } from '../utils/buildPxCheck';
import { validatePxConfigurations } from 'utils';

const POST_ENDPOINTS = {
  POST_WITHOUT_REDEEM_API_ENDPOINT_PATH: '/check/post.json',
  POST_AND_ACCRUE_POINTS_WITH_REDEEM_API_ENDPOINT_PATH:
    '/check/postAndAccruePointsWithRedeem.json',
};

function buildRequest(posContext, order, customer) {
  const check = buildPxCheck(order, customer?.referenceId);

  const cardInfo = {
    printedCardNumber: customer.referenceId,
    phoneNumber: customer.phoneNumber,
  };

  return {
    merchantId: Number(posContext.configurations.merchantId),
    storeCode: posContext.configurations.storeCode,
    check,
    cardInfo,
    autoActivateCard: true,
    terminal: posContext.device.id ?? '0',
    operator: posContext.employee.id ?? '0',
    receiptSettings: [],
  };
}

export function isSuccessResponse(response) {
  return response.result === 'success';
}

export function isFailureResponse(response) {
  return response.result === 'failure';
}

export async function postAndAccruePointswithRedeem(
  posContext,
  pxContext,
  order,
  customer,
  skipAccrueAndRedeem = false // Use in event that we need to post without loyalty redemption e.g. comp cards
) {
  const request = buildRequest(posContext, order, customer);
  const validatedPxConfigurations = validatePxConfigurations(
    posContext.configurations
  );
  const paytronixDomain = validatedPxConfigurations.environmentUrl;
  const response = await fetch(
    `${paytronixDomain}${
      skipAccrueAndRedeem
        ? POST_ENDPOINTS.POST_WITHOUT_REDEEM_API_ENDPOINT_PATH
        : POST_ENDPOINTS.POST_AND_ACCRUE_POINTS_WITH_REDEEM_API_ENDPOINT_PATH
    }`,
    {
      body: JSON.stringify(request),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Basic ${pxContext.authorizationToken}`,
      },
    }
  ).then((result) => result.json());

  return response;
}
